import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
                fill: "#1E2531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.57471 7.49999C7.77063 6.94304 8.15733 6.47341 8.66634 6.17426C9.17534 5.87512 9.77379 5.76577 10.3557 5.86558C10.9376 5.96539 11.4654 6.26792 11.8456 6.71959C12.2258 7.17126 12.4339 7.74292 12.433 8.33332C12.433 9.99999 9.93304 10.8333 9.93304 10.8333V12.0833",
                stroke: "#E3E4E7",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 14.1665H10.0083",
                stroke: "#E3E4E7",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};
export default Icon;
